
import { computed, defineComponent, inject, PropType } from 'vue';
import { useBreakpoint, useVModel } from 'vue-composable';
import { BREAKPOINTS } from '@/constants';
import { WeightedOption, YourNetwork } from '@/types';
import { ShowToast } from '@/providers/Toast/toast-types';

export default defineComponent({
  name: 'SurveyRelationships',
  emits: ['update:relationships'],
  props: {
    text: {
      type: String,
      required: true,
      default: ''
    },
    options: {
      type: Object as PropType<WeightedOption[]>,
      required: true
    },
    yourNetwork: {
      type: Object as PropType<YourNetwork[]>,
      required: true
    },
    userId: {
      type: String,
      required: true,
      default: ''
    }
  },
  setup(props) {
    const { laptop } = useBreakpoint(BREAKPOINTS);
    const yourNetworkRef = useVModel(props, 'yourNetwork');
    const showToast = inject<ShowToast>('showToast')!;

    const empty = computed(() => yourNetworkRef.value.some((ref) => ref.relationshipKeys.length === 0));

    const validate = () => {
      const valid = true;
      if (empty.value) {
        showToast({
          headline: 'Error',
          message: 'Please select at least one option for each person.',
          color: 'danger'
        });
        return !valid;
      }
      return valid;
    };

    return { laptop, yourNetworkRef, validate };
  }
});
